import { render, staticRenderFns } from "./CommunicationEmail.vue?vue&type=template&id=671f871e&"
import script from "./CommunicationEmail.vue?vue&type=script&lang=js&"
export * from "./CommunicationEmail.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports